export default __webpack_public_path__ + "static/media/ReimbarsmentIcon.7a5a2ffb.svg";